<template>
  <div style="background-color: #fff">
    <titleBox name="旷真案例" imgUrl="../../assets/zhichanBg.jpg"></titleBox>
    <div class="cateNav">
      <span v-for="(item, index) in tabs" :key="item.type" class="cateItem">
        <a
          :class="{ active: currentTab.type === item.type }"
          @click="changeType(item.type)"
          >{{ item.title }}</a
        >
        <span v-if="index < tabs.length - 1" class="sep">|</span>
      </span>
    </div>
    <div class="case-list">
      <div
        class="case-item"
        v-for="article in list"
        :key="article.id"
        @click="toDetail(article)"
      >
        <div class="date">{{ formatDate(displayTime(article)) }}</div>
        <div class="title">{{ article.title }}</div>
        <div class="msg">{{ article.summary }}</div>
        <div class="watchMsg">→</div>
      </div>
      <div class="empty" v-if="loaded && list.length === 0">暂无案例</div>
      <div class="loadMore" v-show="loadMoreFlag" @click="loadMoreNews">
        加载更多...
      </div>
    </div>
  </div>
</template>

<script>
import titleBox from "../../components/titleBox/index";
import req from "../../utils/index";

const tabs = [
  { type: "family", title: "家事案例", cid: "47" },
  { type: "criminal", title: "刑事案例", cid: "48" },
  { type: "receivable", title: "应收款案例", cid: "50" },
];

export default {
  components: { titleBox },
  data() {
    return {
      tabs,
      list: [],
      loadMoreFlag: false,
      loaded: false,
      pageNum: 1,
      skipPageWatch: false,
    };
  },
  computed: {
    currentTab() {
      const type = this.$route.params.type;
      return this.tabs.find((item) => item.type === type) || this.tabs[0];
    },
  },
  watch: {
    "$route.params.type": {
      immediate: true,
      handler(type, prevType) {
        const index = this.tabs.findIndex((item) => item.type === type);
        if (index < 0) {
          this.$router.replace("/cases/family");
          return;
        }
        // 同分类仅 query.page 变化（浏览器后退）时不要整表重置
        if (prevType && prevType === type) {
          return;
        }
        this.restoreListFromRoute();
      },
    },
    "$route.query.page"(page) {
      // 加载更多主动改 URL 时跳过，避免整表重拉
      if (this.skipPageWatch) {
        this.skipPageWatch = false;
        return;
      }
      const n = this.parsePage(page);
      if (n === this.pageNum && this.list.length) return;
      this.restoreListFromRoute();
    },
  },
  methods: {
    parsePage(page) {
      const n = parseInt(page, 10);
      return n > 0 ? n : 1;
    },
    syncPageToRoute(page, fromLoadMore) {
      const query = { ...this.$route.query };
      if (page > 1) {
        query.page = String(page);
      } else {
        delete query.page;
      }
      const cur = String(this.$route.query.page || "");
      const next = page > 1 ? String(page) : "";
      if (cur === next) return;
      if (fromLoadMore) {
        this.skipPageWatch = true;
      }
      this.$router
        .replace({ path: `/cases/${this.currentTab.type}`, query })
        .catch(() => {});
    },
    displayTime(item) {
      const configured =
        item &&
        item.fields &&
        item.fields.field_display_time &&
        String(item.fields.field_display_time).trim();
      return configured || (item && item.time) || "";
    },
    formatDate(time) {
      if (!time) return "";
      return String(time).substring(0, 10).replace(/-/g, ".");
    },
    changeType(type) {
      if (this.$route.params.type !== type) {
        this.$router.replace({ path: "/cases/" + type });
      }
    },
    toDetail(item) {
      this.syncPageToRoute(this.pageNum);
      const tag =
        item.fields && item.fields.field_type ? item.fields.field_type : "";
      this.$router.push({
        name: "caseDetail",
        params: {
          type: this.currentTab.type,
          id: String(item.id),
        },
        query: {
          tag,
        },
      });
    },
    loadMoreNews() {
      this.pageNum = Number(this.pageNum) + 1;
      this.syncPageToRoute(this.pageNum, true);
      this.search();
    },
    // 按 URL 中的 page（已加载页数）一次拉回列表，便于后退还原
    restoreListFromRoute() {
      const pages = this.parsePage(this.$route.query.page);
      this.list = [];
      this.pageNum = pages;
      this.loadMoreFlag = false;
      this.loaded = false;
      this._listCid = null;
      const tab = this.currentTab;
      const cids = [tab.cid].concat(tab.fallbackCids || []);
      const limit = pages * 10;
      const tryFetch = (index) => {
        const cid = cids[index];
        if (!cid) {
          this.loaded = true;
          return;
        }
        req("post", "api/base/articlelist", {
          Cid: cid,
          Page: 1,
          Limit: limit,
        }).then((res) => {
          if (this.currentTab.type !== tab.type) return;
          const rows = res.data || [];
          const total = res.count || 0;
          if (!rows.length && !total && index < cids.length - 1) {
            tryFetch(index + 1);
            return;
          }
          this._listCid = cid;
          this.list = rows;
          this.loadMoreFlag = rows.length >= limit;
          this.loaded = true;
        });
      };
      tryFetch(0);
    },
    search() {
      const tab = this.currentTab;
      const cids = this._listCid
        ? [this._listCid]
        : [tab.cid].concat(tab.fallbackCids || []);
      const tryFetch = (index) => {
        const cid = cids[index];
        if (!cid) {
          this.loaded = true;
          return;
        }
        req("post", "api/base/articlelist", {
          Cid: cid,
          Page: this.pageNum,
          Limit: 10,
        }).then((res) => {
          if (this.currentTab.type !== tab.type) return;
          const rows = res.data || [];
          const total = res.count || 0;
          if (
            this.pageNum === 1 &&
            !rows.length &&
            !total &&
            index < cids.length - 1
          ) {
            tryFetch(index + 1);
            return;
          }
          this._listCid = cid;
          this.list = this.list.concat(rows);
          this.loadMoreFlag = rows.length >= 10;
          this.loaded = true;
        });
      };
      tryFetch(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.cateNav {
  width: 92%;
  margin: 0.2rem auto 0;
  text-align: center;
  padding: 0.24rem 0 0.1rem;
  .cateItem {
    display: inline;
  }
  a {
    display: inline-block;
    font-size: 0.3rem;
    color: #333;
    padding: 0 0.08rem;
    line-height: 0.48rem;
  }
  a.active {
    color: #ab0000;
    font-weight: 700;
  }
  .sep {
    color: #ccc;
    margin: 0 0.18rem;
    font-size: 0.26rem;
  }
}
.case-list {
  width: 92%;
  margin: 0 auto;
  padding-bottom: 0.4rem;
  min-height: 6rem;
}
.case-item {
  padding: 0.36rem 0.28rem 0.3rem;
  margin-top: 0.24rem;
  border: 1px solid #eeeeee;
  border-radius: 0.08rem;
  .date {
    color: #ab0000;
    font-size: 0.36rem;
    margin-bottom: 0.16rem;
  }
  .title {
    color: #555555;
    font-size: 0.36rem;
    font-weight: 700;
    line-height: 0.52rem;
  }
  .msg {
    margin-top: 0.16rem;
    font-size: 0.28rem;
    color: #888888;
    line-height: 0.44rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .watchMsg {
    margin-top: 0.2rem;
    color: #ab0000;
    font-size: 0.34rem;
    line-height: 1;
  }
}
.empty,
.loadMore {
  padding: 0.5rem 0;
  text-align: center;
  color: #999999;
  font-size: 0.3rem;
}
</style>
